<template>
  <div class="rate-card-search-page">
    <v-row>
      <v-col cols="12">
        <section class="rate-card-search-panel">
          <div class="rate-card-search-primary">
            <v-text-field
              v-model="filter"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              hide-details
              label="Search rate cards"
              placeholder="Name, handle, email, country or category"
              class="rate-card-search-input"
              @keyup.enter="searchFilter()"
            ></v-text-field>
            <v-btn color="secondary" class="rate-card-search-submit" @click="searchFilter()">
              <v-icon left small>mdi-magnify</v-icon>Search
            </v-btn>
            <v-btn outlined class="rate-card-filters-toggle" @click="filtersExpanded = !filtersExpanded">
              <v-icon left small>mdi-tune-variant</v-icon>
              Filters
              <span v-if="activeFilterCount" class="rate-card-filter-count">{{activeFilterCount}}</span>
              <v-icon right small>{{filtersExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
            </v-btn>
            <v-btn outlined class="rate-card-reset-toggle" @click="resetFilters(); searchFilter()">
              <v-icon left small>mdi-refresh</v-icon>Reset
            </v-btn>
          </div>

          <v-expand-transition>
            <div v-show="filtersExpanded" class="rate-card-filters-accordion">
              <div class="rate-card-advanced-filters__header">
                <div>
                  <span>Advanced filters</span>
                  <small>Audience size, profile details, categories and pricing</small>
                </div>
                <v-icon color="#8b92a5">mdi-tune-variant</v-icon>
              </div>
        <v-card-title class="rate-card-filter-bar">
          <v-row align="center" style="justify-content: right">
            <v-col class="pt-5" cols="12" xs="12" md="1" style="min-width:135px;max-width:135px">
              <v-checkbox
                class="mt-0 pr-4"
                v-model="filters.starOnly"
                label="Star Only"
                color="secondary"
                :value="false"
                hide-details
                @change="searchFilter()"
              ></v-checkbox>
            </v-col>
            <v-col class="pt-5" cols="12" xs="12" md="2" style="max-width:200px">
              <v-menu
                offset-y
                bottom
                transition="scale-transition"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                  >
                    TikTok Followers <v-icon right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-list min-height="100px">
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        From
                        <v-combobox
                          outlined
                          dense        
                          clearable
                          hide-details="auto"
                          :items="rateCardConfig.followerOptions.from"
                          v-model="filters.tiktokFollowers.from"
                          style="max-width:120px;" 
                        ></v-combobox>
                      </v-col>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        To
                        <v-combobox
                          outlined
                          dense        
                          clearable
                          hide-details="auto"
                          :items="rateCardConfig.followerOptions.to"
                          v-model="filters.tiktokFollowers.to"
                          style="max-width:120px;"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        <v-checkbox
                          class="mt-0"
                          v-model="filters.isTikTokEmpty"
                          label="Empty"
                          color="secondary"
                          value="orange"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                
                <v-list min-height="100px" style="min-height:60px;margin-top:-28px">
                  <v-list-item style="float:right">
                    <v-btn color="secondary" small @click.stop="searchTikTokFollower()">
                      Apply
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col class="pt-5" cols="12" xs="12" md="2" style="max-width:165px">
              <v-menu
                offset-y
                bottom
                transition="scale-transition"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                  >
                    IG Followers <v-icon right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-list min-height="100px">
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        From
                        <v-combobox
                          outlined
                          dense        
                          clearable
                          hide-details="auto"
                          :items="rateCardConfig.followerOptions.from"
                          v-model="filters.followers.from"
                          style="max-width:120px;" 
                        ></v-combobox>
                      </v-col>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        To
                        <v-combobox
                          outlined
                          dense        
                          clearable
                          hide-details="auto"
                          :items="rateCardConfig.followerOptions.to"
                          v-model="filters.followers.to"
                          style="max-width:120px;"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        <v-checkbox
                          class="mt-0"
                          v-model="filters.isIgEmpty"
                          label="Empty"
                          color="secondary"
                          value="orange"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                
                <v-list min-height="100px" style="min-height:60px;margin-top:-28px">
                  <v-list-item style="float:right">
                    <v-btn color="secondary" small @click.stop="searchIGFollower()">
                      Apply
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col class="pt-5" cols="12" xs="12" md="2" style="max-width:100px">
              <v-menu
                offset-y
                bottom
                transition="scale-transition"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                  >
                    Rate <v-icon right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-list min-height="100px">
                  <v-list-item class="mb-2">
                    <v-row>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        Content Type
                        <v-select
                          outlined
                          dense
                          clearable
                          color="secondary"
                          hide-details="auto"
                          :items="contentTypes"
                          item-text="title"
                          return-object
                          v-model="filters.contentType"
                          class="rate-card-content-type-input"
                          style="max-width:100%;"
                        >
                          <template v-slot:item="{ item }">
                            <div
                              class="rate-card-content-type-option"
                              :style="{ '--media-icon-color': item.iconColor || '#616161' }"
                            >
                              <v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>
                              <img v-else-if="item.imgIcon" :src="item.imgIcon" alt="" aria-hidden="true">
                              <span>{{ item.title }}</span>
                            </div>
                          </template>
                          <template v-slot:selection="{ item }">
                            <div
                              class="rate-card-content-type-option rate-card-content-type-option--selected"
                              :style="{ '--media-icon-color': item.iconColor || '#616161' }"
                            >
                              <v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>
                              <img v-else-if="item.imgIcon" :src="item.imgIcon" alt="" aria-hidden="true">
                              <span>{{ item.title }}</span>
                            </div>
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="mb-2">
                    <v-row>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        Currency
                        <v-combobox
                          outlined
                          dense
                          clearable
                          color="secondary"
                          hide-details="auto"
                          :items="currencyOptions"
                          v-model="filters.rateCurrency"
                          class="rate-card-rate-input"
                          style="max-width:100%;"
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="mb-2">
                    <v-row>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        From
                        <v-text-field
                          outlined
                          dense
                          clearable
                          color="secondary"
                          type="number"
                          hide-details="auto"
                          v-model="filters.rate.from"
                          class="rate-card-rate-input"
                          style="max-width:120px;" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xs="12" md="6" lg="6">
                        To
                        <v-text-field
                          outlined
                          dense
                          clearable
                          color="secondary"
                          type="number"
                          hide-details="auto"
                          v-model="filters.rate.to"
                          class="rate-card-rate-input"
                          style="max-width:120px;" 
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                
                <v-list min-height="100px" style="min-height:60px;">
                  <v-list-item class="rate-card-rate-actions">
                    <v-btn text small color="secondary" @click.stop="clearRateFilters()">
                      Clear all
                    </v-btn>
                    <v-btn color="secondary" small @click.stop="searchFilter()">
                      Apply
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col class="pt-5" cols="12" xs="12" md="2">
              <v-autocomplete
                style="max-width:300px"
                v-model="filters.country"
                :items="countries"
                item-value="value"
                item-text="text"
                clearable
                outlined
                dense
                hide-details="auto"
                label="Country"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </v-col>
            <v-col class="pt-5" cols="12" xs="12" md="1" style="min-width:150px;max-width:150px">
              <v-menu
                ref="DOBDatePicker"
                v-model="dateOfBirthCal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                dense
                max-width="350px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="Date of Birth"
                    placeholder="Date of Birth"
                    v-model="filters.dateOfBirth"
                    @change="searchFilter"
                    dense
                    readonly
                    outlined
                    clearable
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.dateOfBirth"
                  type="month"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="secondary"
                      @click="cancelDOB()"
                  >
                      Cancel
                  </v-btn>
                  <v-btn
                      text
                      color="secondary"
                      @click="searchFilter"
                  >
                      OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="pt-5" cols="12" xs="12" md="2">
              <v-autocomplete
                style="max-width:300px"
                v-model="filters.category"
                :items="categories"
                item-value="value"
                item-text="text"
                clearable
                outlined
                dense
                hide-details="auto"
                label="Preferred Campaigns/Genre"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </v-col>
            <v-col class="pt-5" cols="12" xs="12" md="2">
              <v-autocomplete
                style="max-width:300px"
                v-model="filters.mainCategory"
                :items="rateCardLabels"
                clearable
                outlined
                dense
                hide-details="auto"
                label="Main Category"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </v-col>
            <v-col class="pt-5" cols="12" xs="12" md="2">
              <v-autocomplete
                style="max-width:300px"
                v-model="filters.subCategory"
                :items="rateCardLabels"
                clearable
                outlined
                dense
                hide-details="auto"
                label="Sub Category"
                @change="searchFilter"                    
              >
              </v-autocomplete>
            </v-col>
            <v-col class="pt-5 rate-card-filter-legacy-tool" cols="12" xs="12" md="2">
              <v-text-field style="max-width:300px" v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-col>
            <v-col style="max-width:50px;" class="pt-5 pa-0 rate-card-filter-legacy-tool" cols="12" xs="12" md="2">
              <v-menu
                bottom
                transition="scale-transition"
                :close-on-content-click="false"
                style="margin-left:-25px;"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    <v-icon>mdi-sort</v-icon>
                  </v-btn>
                </template>
                <v-list style="max-width:230px" min-height="100px">
                  <v-list-item>
                    <v-row>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        Sort By
                        <v-select
                          outlined
                          dense
                          clearable
                          hide-details="auto"
                          :items="sortColumns"
                          v-model="sort.column"
                          style="max-width:200px;" 
                        ></v-select>
                      </v-col>
                      <v-col cols="12" xs="12" md="12" lg="12" v-if="isSortCurrency">
                        Currency
                        <v-select
                          outlined
                          dense
                          clearable
                          hide-details="auto"
                          :items="currencyOptions"
                          v-model="sort.currency"
                          style="max-width:200px;"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" xs="12" md="12" lg="12">
                        Type
                        <v-select
                          outlined
                          dense
                          hide-details="auto"
                          :items="sortTypes"
                          v-model="sort.type"
                          style="max-width:200px;" 
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                <v-list min-height="100px" style="min-height:60px;margin-top:-20px">
                  <v-list-item style="float:right">
                    <v-btn color="secondary" small @click.stop="searchFilter()">
                      Apply
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col style="max-width:50px;" class="pt-5 pa-0 rate-card-filter-legacy-tool" cols="12" xs="12" md="2">
              <v-menu
                :close-on-content-click="false"
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openColSettingsModal"
                  >
                    <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                  </v-btn>
                </template>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-title>
            </div>
          </v-expand-transition>
        </section>

        <section class="rate-card-results-panel">
          <div class="rate-card-results-toolbar">
            <span class="rate-card-results-count"><strong>{{filteredItems.length}}</strong> rate cards</span>
            <div class="rate-card-results-toolbar__actions">
              <v-menu bottom left transition="scale-transition" :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon color="secondary" v-bind="attrs" v-on="on" text>
                    <v-icon>mdi-sort</v-icon>
                  </v-btn>
                </template>
                <v-card width="250" class="pa-3">
                  <v-select outlined dense clearable hide-details="auto" label="Sort by" :items="sortColumns" v-model="sort.column"></v-select>
                  <v-select v-if="isSortCurrency" class="mt-3" outlined dense clearable hide-details="auto" label="Currency" :items="currencyOptions" v-model="sort.currency"></v-select>
                  <v-select class="mt-3" outlined dense hide-details="auto" label="Direction" :items="sortTypes" v-model="sort.type"></v-select>
                  <div class="text-right mt-3">
                    <v-btn color="secondary" small @click.stop="searchFilter()">Apply</v-btn>
                  </div>
                </v-card>
              </v-menu>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    class="rate-card-column-settings"
                    aria-label="Column settings"
                    v-bind="attrs"
                    v-on="on"
                    @click="openColSettingsModal"
                  >
                    <i class="fas fa-cog fa-lg" aria-hidden="true"></i>
                  </v-btn>
                </template>
                <span>Column settings</span>
              </v-tooltip>
            </div>
          </div>
        <!-- BEGIN vue data table -->
        <v-data-table
        id="rate-card-data-table"
        :headers="computedHeaders" 
        :search="filter" 
        :items="filteredItems" 
        class="elevation-1 rate-card-table">
          <template v-slot:[`item.name`]="{ item }">
            <td class="text-left">
              {{item.name}}
            </td>
          </template>
          <template v-slot:[`item.email`]="{ item }">
            <td class="text-left">
              {{item.email}}
            </td>
          </template>
          <template v-slot:[`item.dateOfBirth`]="{ item }">
            <td class="text-left" style="min-width:120px!important">
              {{item.dateOfBirth ? utils.formatCustomDate(item.dateOfBirth, 'DD MMM, YYYY') : ''}}
            </td>
          </template>
          <template v-slot:[`item.ethnicity`]="{ item }">
            <td class="text-left">
              {{item.ethnicity && item.ethnicity !== 'Others' ? item.ethnicity : ''}}
              {{item.otherEth ? item.otherEth : ''}}
            </td>
          </template>
          <template v-slot:[`item.country`]="{ item }">
            <td class="text-left">
              {{item.country}}
            </td>
          </template>
          <template v-slot:[`item.city`]="{ item }">
            <td class="text-left">
              {{item.city}}
            </td>
          </template>
          <template v-slot:[`item.gender`]="{ item }">
            <td class="text-left">
              {{item.gender}}
            </td>
          </template>
          <template v-slot:[`item.contactNo`]="{ item }">
            <td class="text-left">
              {{item.contactNo}}
            </td>
          </template>
          <template v-slot:[`item.instagramHandle`]="{ item }">
            <td class="text-left">
              <social-handle
                :isInstagram="true"
                :instagramHandle="item.instagramHandle"
                v-if="item.instagramHandle"
              />
            </td>
          </template>
          <template v-slot:[`item.igFollowerCount`]="{ item }">
            <td class="text-left">
              {{item.igFollowerCount | thousandSeprator}}
            </td>
          </template>
          <template v-slot:[`item.tiktokHandle`]="{ item }">
            <td class="text-left">
              <social-handle
                :isTikTok="true"
                :tiktokHandle="item.tiktokHandle"
                v-if="item.tiktokHandle"
              />
            </td>
          </template>
          <template v-slot:[`item.tiktokFollowerCount`]="{ item }">
            <td class="text-left">
              {{item.tiktokFollowerCount | thousandSeprator}}
            </td>
          </template>
          <template v-slot:[`item.youtube`]="{ item }">
            <td class="text-left" style="max-width:120px">
              <div v-if="getPlatformUrl(item, 'youtube')">
                <a :href="getPlatformUrl(item, 'youtube')" target="_blank" style="line-break:anywhere"><v-icon>mdi-youtube</v-icon> {{getHandlePreview(item, 'youtube')}}</a>
              </div>
            </td>
          </template>
          <template v-slot:[`item.youtubeFollowerCount`]="{ item }">
            <td class="text-left">{{ item.youtubeFollowerCount | thousandSeprator }}</td>
          </template>
          <template v-slot:[`item.youtubeRate`]="{ item }">
            <td class="text-left">
              <span v-if="getPlatformRate(item, 'youtube')">{{ getPlatformRateCurrency(item, 'youtube') }} {{ getPlatformRate(item, 'youtube') | thousandSeprator }}</span>
            </td>
          </template>
          <template v-slot:[`item.facebook`]="{ item }">
            <td class="text-left" style="max-width:120px">
              <div v-if="getPlatformUrl(item, 'facebook')">
                <a :href="getPlatformUrl(item, 'facebook')" target="_blank" style="line-break:anywhere"><v-icon>mdi-facebook</v-icon> {{getHandlePreview(item, 'facebook')}}</a>
              </div>
            </td>
          </template>
          <template v-slot:[`item.linkedin`]="{ item }">
            <td class="text-left" style="max-width:120px">
              <div v-if="getPlatformUrl(item, 'linkedin')">
                <a :href="getPlatformUrl(item, 'linkedin')" target="_blank" style="line-break:anywhere"><v-icon color="#0A66C2">mdi-linkedin</v-icon> {{getHandlePreview(item, 'linkedin')}}</a>
              </div>
            </td>
          </template>
          <template v-slot:[`item.facebookFollowerCount`]="{ item }">
            <td class="text-left">{{ item.facebookFollowerCount | thousandSeprator }}</td>
          </template>
          <template v-slot:[`item.facebookRate`]="{ item }">
            <td class="text-left">
              <span v-if="getPlatformRate(item, 'facebook')">{{ getPlatformRateCurrency(item, 'facebook') }} {{ getPlatformRate(item, 'facebook') | thousandSeprator }}</span>
            </td>
          </template>
          <template v-slot:[`item.linkedinFollowerCount`]="{ item }">
            <td class="text-left">{{ item.linkedinFollowerCount | thousandSeprator }}</td>
          </template>
          <template v-slot:[`item.linkedinRate`]="{ item }">
            <td class="text-left">
              <span v-if="getPlatformRate(item, 'linkedin')">{{ getPlatformRateCurrency(item, 'linkedin') }} {{ getPlatformRate(item, 'linkedin') | thousandSeprator }}</span>
            </td>
          </template>
          <template v-slot:[`item.twitter`]="{ item }">
            <td class="text-left" style="max-width:120px">
              <div v-if="getPlatformUrl(item, 'twitter')">
                <a :href="getPlatformUrl(item, 'twitter')" target="_blank" style="line-break:anywhere"><img src="/static/img/x-logo.svg" width="15" class="mr-1" alt="X (Twitter)"> {{getHandlePreview(item, 'twitter')}}</a>
              </div>
            </td>
          </template>
          <template v-slot:[`item.twitterFollowerCount`]="{ item }">
            <td class="text-left">{{ item.twitterFollowerCount | thousandSeprator }}</td>
          </template>
          <template v-slot:[`item.twitterRate`]="{ item }">
            <td class="text-left">
              <span v-if="getPlatformRate(item, 'twitter')">{{ getPlatformRateCurrency(item, 'twitter') }} {{ getPlatformRate(item, 'twitter') | thousandSeprator }}</span>
            </td>
          </template>
          <template v-slot:[`item.twitch`]="{ item }">
            <td class="text-left" style="max-width:120px">
              <div v-if="getPlatformUrl(item, 'twitch')">
                <a :href="getPlatformUrl(item, 'twitch')" target="_blank" style="line-break:anywhere">{{getHandlePreview(item, 'twitch')}}</a>
              </div>
            </td>
          </template>
          <template v-slot:[`item.twitchFollowerCount`]="{ item }">
            <td class="text-left">{{ item.twitchFollowerCount | thousandSeprator }}</td>
          </template>
          <template v-slot:[`item.twitchRate`]="{ item }">
            <td class="text-left">
              <span v-if="getPlatformRate(item, 'twitch')">{{ getPlatformRateCurrency(item, 'twitch') }} {{ getPlatformRate(item, 'twitch') | thousandSeprator }}</span>
            </td>
          </template>
          <template v-slot:[`item.igStory`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.igStoryCurrency}} {{item.ordinaryRates.igStory | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.igPost`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.igPostCurrency}} {{item.ordinaryRates.igPost | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.igCarousel`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.igCarouselCurrency}} {{item.ordinaryRates.igCarousel | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.igVideo`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.igVideoCurrency}} {{item.ordinaryRates.igVideo | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.igReel`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.igReelCurrency}} {{item.ordinaryRates.igReel | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.igRemarks`]="{ item }">
            <td class="text-left" style="min-width:120px!important">
              <v-tooltip bottom max-width="300px">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <p class="remark-text">{{item.igRemarks || '-'}}</p>
                  </div>
                </template>
                <span v-html="formatDesc(item.igRemarks)"></span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:[`item.tiktok`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.tiktokCurrency}} {{item.ordinaryRates.tiktok | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.tiktokRemarks`]="{ item }">
            <td class="text-left" style="min-width:120px!important">
              <v-tooltip bottom max-width="300px">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <p class="remark-text">{{item.tiktokRemarks || '-'}}</p>
                  </div>
                </template>
                <span v-html="formatDesc(item.tiktokRemarks)"></span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:[`item.eventAppearance`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.eventAppearanceCurrency}} {{item.ordinaryRates.eventAppearance | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.loadingFee`]="{ item }">
            <td class="text-left">
              <span v-if="item.ordinaryRates">{{item.ordinaryRates.loadingFeeCurrency}} {{item.ordinaryRates.loadingFee | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.uploadMediaKit`]="{ item }">
            <td class="text-left">
              <v-btn
                small
                text
                color="secondary"
                v-for="(deck, idx) in item.pricingDecks"
                :key="idx"
                :href="deck.url"
                target="_blank"
              >
                View Media
              </v-btn>
            </td>
          </template>
          <template v-slot:[`item.preferredCampaigns`]="{ item }">
            <td class="text-left">
              <v-chip
                v-if="!item.keywords || item.keywords.length === 0"
                class="ma-2"
                color="#ffffff"
                x-small
                text-color="black"
                style="text-transform: capitalize;"
              >{{'-'}}</v-chip>
              <v-chip                                 
                v-else                              
                v-for="(keyword, index) in item.keywords"
                :key="index"
                v-show="index === 0"
                class="ma-2"
                x-small             
              >{{keyword}}</v-chip> 
              <v-menu                                                            
                v-show="item.keywords"      
                :close-on-content-click="false"    
                top                                                 
                offset-x                              
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :id="'btnMore_'+item.id"
                    v-show="item.keywords && item.keywords.length > 1"                       
                    color="secondary"
                    x-small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    More...
                  </v-btn>
                </template>
                <v-card max-width="300" style="text-align: left;">
                  <v-card-text>
                    <div>Preferred Campaigns / Genre</div>
                    <v-divider></v-divider>                                    
                    <v-chip                                      
                      v-for="(interest, index) in item.keywords"
                      :key="index"
                      v-show="index !== 0"
                      class="ma-2"
                      small           
                    >{{interest}}</v-chip>
                  </v-card-text>
                </v-card>
              </v-menu>
            </td>
          </template>
          <template v-slot:[`item.labelDisplays`]="{ item }">
            <td class="text-left">
              <v-chip
                v-if="!item.mainCategories || item.mainCategories.length === 0"
                class="ma-2"
                color="#ffffff"
                x-small
                text-color="black"
                style="text-transform: capitalize;"
              >{{'-'}}</v-chip>
              <v-chip                                 
                v-else      
                class="ma-2"
                x-small             
              >{{item.mainCategories}}</v-chip> 
              <v-menu                                                            
                v-show="item.mainCategories"      
                :close-on-content-click="false"    
                top                                                 
                offset-x                              
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :id="'btnMore_'+item.id"
                    v-show="item.mainCategories && item.mainCategories.length > 0"
                    color="secondary"
                    x-small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    More...
                  </v-btn>
                </template>
                <v-card max-width="300" style="text-align: left;">
                  <div>
                    <v-card-text>
                      <div class="font-weight-bold">Main Category</div>
                      <v-divider></v-divider>                                    
                      <v-chip                                      
                        class="ma-2"
                        small           
                      >{{item.mainCategories}}</v-chip>
                    </v-card-text>
                    <v-card-text>
                      <div class="font-weight-bold">Sub Category</div>
                      <v-divider></v-divider>                                    
                      <v-chip                                      
                        v-for="(sub, index) in item.subCategories"
                        :key="index"
                        class="ma-2"
                        small           
                      >{{sub}}</v-chip>
                    </v-card-text>
                  </div>
                </v-card>
              </v-menu>
            </td>
          </template>
          <template v-slot:[`item.labels`]="{ item }">
            <td class="text-left">
              <!-- <v-chip
                v-if="!item.labels || item.labels.length === 0"
                class="ma-2"
                color="#ffffff"
                x-small
                text-color="black"
                style="text-transform: capitalize;"
              >{{'-'}}</v-chip>
              <v-chip                                 
                v-else                              
                v-for="(keyword, index) in item.labels"
                :key="index"
                v-show="index === 0"
                class="ma-2"
                x-small             
              >{{keyword}}</v-chip> 
              <v-menu                                                            
                v-show="item.labels"      
                :close-on-content-click="false"    
                top                                                 
                offset-x                              
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :id="'btnMore_'+item.id"
                    v-show="item.labels && item.labels.length > 0"
                    color="secondary"
                    x-small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    More...
                  </v-btn>
                </template>
                <v-card max-width="300" style="text-align: left;">
                  <v-card-text>
                    <div class="font-weight-bold">Labellings</div>
                    <v-divider></v-divider>                                    
                    <v-chip                                      
                      v-for="(label, index) in item.labels"
                      :key="index"
                      v-show="index !== 0"
                      class="ma-2"
                      small           
                    >{{label}}</v-chip>
                  </v-card-text>
                </v-card>
              </v-menu> -->
              <!-- Add Labels -->
              <v-menu                     
                :close-on-content-click="false"    
                top                                                 
                offset-x                              
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mb-1 pa-0"           
                    color="secondary"
                    small
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    <v-icon small>edit</v-icon>  Label
                  </v-btn>
                </template>
                <v-card max-width="300" style="text-align: left;">
                  <div>
                    <v-card-text>
                      <div class="font-weight-bold">Main Category</div>
                      <v-divider style="margin-bottom:0"></v-divider>
                      <v-chip-group
                      active-class="primary--text"
                      v-model="item.mainCategories"
                      column
                      required
                      @change="changeLabel(item)">                                    
                        <v-chip                                      
                          v-for="(label, index) in rateCardLabels"
                          :key="index"
                          :value="label"
                          class="ma-2"
                          small           
                        >{{label}}</v-chip>
                      </v-chip-group>
                    </v-card-text>
                    <v-card-text>
                      <div class="font-weight-bold">Sub Category</div>
                      <v-divider style="margin-bottom:0"></v-divider>
                      <v-chip-group
                      multiple
                      active-class="primary--text"
                      v-model="item.subCategories"
                      column
                      required
                      @change="changeLabel(item)">                                    
                        <v-chip                                      
                          v-for="(label, index) in rateCardLabels"
                          :key="index"
                          :value="label"
                          class="ma-2"
                          small           
                        >{{label}}</v-chip>
                      </v-chip-group>
                    </v-card-text>
                  </div>
                </v-card>
              </v-menu>
            </td>
          </template>
          <template v-slot:[`item.aboutYou`]="{ item }">
            <td class="text-left">
              <v-tooltip bottom max-width="300px">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <p class="remark-text">{{item.aboutYou || '-'}}</p>
                  </div>
                </template>
                <span v-html="formatDesc(item.aboutYou)"></span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:[`item.loadContent`]="{ item }">
            <td class="text-left">
              {{item.loadContent}}
              {{item.loadContentText}}
            </td>
          </template>
          <template v-slot:[`item.giftBrand`]="{ item }">
            <td class="text-left">
              {{item.giftBrand}}
            </td>
          </template>
          <template v-slot:[`item.engagement`]="{ item }">
            <td class="text-left">
              <span v-if="item.engagement">{{item.engagement | thousandSeprator}}</span>
            </td>
          </template>
          
          <template v-slot:[`item.views`]="{ item }">
            <td class="text-left">
              <span v-if="item.views">{{item.views | thousandSeprator}}</span>
            </td>
          </template>
          <template v-slot:[`item.updatedAt`]="{ item }">
            <td class="text-left">
              {{utils.formatCustomDate(item.updatedAt, 'DD-MM-YYYY') }}
            </td>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <td class="justify-center layout px-0">
              <!-- Star Button -->
              <v-btn
                data-toggle="tooltip" data-placement="top" title="Unstar"
                class="mt-2"
                icon
                small
                color="secondary"
                v-bind="attrs"
                v-on="on"
                text
                @click="chgStarStatus(item, false)"
                v-if="item.star"
              >
                <v-icon>mdi-star</v-icon>
              </v-btn>
              <v-btn
                data-toggle="tooltip" data-placement="top" title="Star"
                class="mt-2"
                icon
                small
                color="secondary"
                v-bind="attrs"
                v-on="on"
                text
                @click="chgStarStatus(item, true)"
                v-else
              >
                <v-icon>mdi-star-outline</v-icon>
              </v-btn>
              <!-- View Button -->
              <v-btn @click="getDataToView(item)" class="mt-2" color="secondary" icon small text>
                <v-icon color="secondary" data-toggle="tooltip" data-placement="top" title="View Details">remove_red_eye</v-icon>
              </v-btn>
              <!-- Delete Button -->
              <v-btn
                class="mt-2"
                data-toggle="tooltip"
                data-placement="top"
                title="Delete Rate Card"
                @click="deleteRateCard(item.id)"
                color="error"
                text
                icon
                small
                v-if="isAdmin"
              >
                <v-icon color="danger">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:no-data>No Data</template>
        </v-data-table>
        </section>
      </v-col>
    </v-row>
    <!-- View Rate Card modal -->
    <view-modal-dialog
    v-model="viewDialog"
    :value="viewDialog"
    :data="viewData"
    v-if="viewData"/>
    <!-- Table Cols Show Hide Modal -->
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      title="Ratecard Forms"
      :items="tableColsItems"
      @updated="updateTableCols"
    />
    <!-- loading -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex';
import utils from '@/utils'
import ViewModalDialog from './ViewModalDialog';
import SocialHandle from '@/components/scoped/custom/SocialHandle';
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import userAPIs from '../../User/userAPIs';
import config from '@/config';
import rateCardConfig from './config';
import orderBy from 'lodash/orderBy';
import influencerHelper from '../influencerHelper'
import influencerAPIs from '../influencerAPIs';
import countries from '../../../../../static/sources/countries';
import Loading from 'vue-loading-overlay';
// import moment from 'moment';
export default {
  name: 'RateCardDataTable',
  components: {
    ViewModalDialog,
    SocialHandle,
    TableColsShowHideModal,
    Loading
  },
  props: [
    'reload',
    'isDownload'
  ],
  watch: {
    reload(value) {
      if (value) {
        this.resetFilters()
        this.getRateCardLists()
      }
    },
    isDownload(value) {
      if (value) {
        this.downloadRateCardRpt()
      }
    }
  },
  computed: {
    ...mapState({
      items: state => state.influencer.rateCards,
      savedRateCard: state => state.influencer.savedRateCard
    }),
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    isAdmin: function() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    },
    isSortCurrency() {
      let sortCol = this.sort.column
      return sortCol === 'IG Story' || sortCol === 'IG Post' ||
      sortCol === 'IG Carousel' || sortCol === 'IG Reel' || sortCol === 'Loading Fee' ||
      sortCol === 'Event Attendance' || sortCol === 'TikTok'
    },
    activeFilterCount() {
      let count = 0
      const scalarFilters = ['country', 'category', 'mainCategory', 'subCategory', 'contentType', 'rateCurrency', 'dateOfBirth']
      scalarFilters.forEach(key => {
        if (this.filters[key]) count++
      })
      if (this.filters.starOnly) count++
      if (this.filters.isTikTokEmpty) count++
      if (this.filters.isIgEmpty) count++
      if (this.filters.followers && (this.filters.followers.from || this.filters.followers.to)) count++
      if (this.filters.tiktokFollowers && (this.filters.tiktokFollowers.from || this.filters.tiktokFollowers.to)) count++
      if (this.filters.rate && (this.filters.rate.from || this.filters.rate.to)) count++
      return count
    },
    computedHeaders() {
      let rateCardCols = null
      let headers = utils.func.refreshJSON(this.headers)
      headers = headers.map(h => {
        if (h.value === 'labels') {
          h.text = ''
        }
        return h
      })
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.rateCardCols) {
          rateCardCols = Object.assign({}, this.userProfile.tableSettings.rateCardCols)
        }
      }
      if (rateCardCols) {
        headers.forEach(header => {
          if (!Object.prototype.hasOwnProperty.call(rateCardCols, header.value)) {
            rateCardCols[header.value] = true
          }
        })
        this.colStatuses = Object.assign({}, rateCardCols)
      } else {
        // default true if no col status in local storage
        headers.map(header => {
          this.colStatuses[header.value] = true
        })
      }
      return headers.filter(h => {
        if (this.colStatuses[h.value]) {
          return true
        }
        return false
      });
    }
  },
  data() {
    return {
      utils: utils.func,
      viewData: null,
      viewDialog: false,
      rateCardConfig,
      headers: rateCardConfig.tableHeaders,
      rateCardLabels: rateCardConfig.rateCardLabels,
      filteredItems: [],
      exportItems: [],
      filter: '',
      filtersExpanded: false,
      colStatuses: {},
      colSettingsDialog: false,
      dateOfBirthCal: false,
      tableColsItems: [],
      userProfile: {},
      categories: influencerHelper.getCategories('en'),
      currencyOptions: rateCardConfig.currencyOptions,
      contentTypes: [
        { title: 'IG Story', value: 'igStory', icon: 'mdi-instagram', iconColor: '#E1306C' },
        { title: 'IG Post', value: 'igPost', icon: 'mdi-instagram', iconColor: '#E1306C' },
        { title: 'IG Carousel', value: 'igCarousel', icon: 'mdi-instagram', iconColor: '#E1306C' },
        { title: 'IG Video', value: 'igVideo', icon: 'mdi-instagram', iconColor: '#E1306C' },
        { title: 'IG Reel', value: 'igReel', icon: 'mdi-instagram', iconColor: '#E1306C' },
        { title: 'IG TV', value: 'igTv', icon: 'mdi-instagram', iconColor: '#E1306C' },
        { title: 'Loading Fee', value: 'loadingFee', icon: 'mdi-cloud-upload-outline', iconColor: '#607D8B' },
        { title: 'Event Appearance', value: 'eventAppearance', icon: 'mdi-calendar-star', iconColor: '#FF8F00' },
        { title: 'TikTok', value: 'tiktok', imgIcon: '/static/img/tiktok.svg' },
        { title: 'YouTube Post', value: 'youtube', icon: 'mdi-youtube', iconColor: '#FF0000' },
        { title: 'Facebook Post', value: 'facebook', icon: 'mdi-facebook', iconColor: '#1877F2' },
        { title: 'LinkedIn Post', value: 'linkedin', icon: 'mdi-linkedin', iconColor: '#0A66C2' },
        { title: 'X (Twitter) Post', value: 'twitter', imgIcon: '/static/img/x-logo.svg' },
        { title: 'Twitch Post', value: 'twitch', icon: 'mdi-twitch', iconColor: '#9146FF' }
      ],
      sortColumns: [
        'IG followers',
        'TikTok followers',
        'Date of Birth',
        'Last Updated',
        'IG Story',
        'IG Post',
        'IG Carousel',
        'IG Reel',
        'Loading Fee',
        'Event Attendance',
        'TikTok'
      ],
      sortTypes: [
        'Ascending',
        'Descending'
      ],
      sort: {
        column: 'Updated At',
        currency: '',
        type: 'Ascending'
      },
      filters: {
        country: '',
        category: '',
        mainCategory: '',
        subCategory: '',
        followers: {from: '', to: ''},
        tiktokFollowers: {from: '', to: ''},
        contentType: '',
        rateCurrency: '',
        rate: {from: '', to: ''},
        isTikTokEmpty: false,
        isIgEmpty: false,
        starOnly: false
      }
    }
  },
  async mounted() {
    // Retrieve countries manually
    this.countries = countries
    this.countries = this.countries.map(c => c.name)
    // get rate card lists
    await this.getRateCardLists()
    if (this.$route.query.id) {
      let matchItem = this.filteredItems.find(item => item.id === this.$route.query.id)
      this.getDataToView(matchItem)
    }
    await this.getUserProfile()
  },
  methods: {
    clearRateFilters() {
      this.filters.contentType = ''
      this.filters.rateCurrency = ''
      this.filters.rate = {from: '', to: ''}
      this.searchFilter()
    },
    getDataToView(item) {
      this.$router.push({
        path: '/influencers/rate-cards',
        query: {
          id: item.id
        }
      })
      this.viewData = item
      this.viewDialog = true
    },
    async getRateCardLists() {
      await this.$store.dispatch('influencer/getRateCardLists')
      let items = this.items.map(i => {
        return i
      })
      items = items.map(item => {
        if (!item.preferentialRates) { item.preferentialRates = {} }
        if (!item.ordinaryRates) {
          item.ordinaryRates = {
            igStory: item.igStory || 0,
            igStoryCurrency: 'SGD',
            igPost: item.igPost || 0,
            igPostCurrency: 'SGD',
            igCarousel: item.igCarousel || 0,
            igCarouselCurrency: 'SGD',
            igVideo: item.igVideo || 0,
            igVideoCurrency: 'SGD',
            igReel: item.igReel || 0,
            igReelCurrency: 'SGD',
            igTv: item.igTv || 0,
            igTvCurrency: 'SGD',
            loadingFee: item.loadingFee || 0,
            loadingFeeCurrency: 'SGD',
            eventAppearance: item.eventAppearance || 0,
            eventAppearanceCurrency: 'SGD',
            tiktok: item.tiktok || 0,
            tiktokCurrency: 'SGD',
            linkedin: 0,
            linkedinCurrency: 'SGD',
            twitter: 0,
            twitterCurrency: 'SGD',
            facebook: 0,
            facebookCurrency: 'SGD',
            youtube: 0,
            youtubeCurrency: 'SGD',
            twitch: 0,
            twitchCurrency: 'SGD'
          }
        }
        if (!item.keywords) item.keywords = []
        if (!item.mainCategories) item.mainCategories = []
        if (!item.subCategories) item.subCategories = []
        return item
      })
      this.filteredItems = Object.assign([], items)
    },
    getPlatformUrl(item, platform) {
      const platformEntry = this.getPlatformEntry(item, platform)
      return platformEntry && platformEntry.url ? platformEntry.url : ''
    },
    getPlatformRate(item, platform) {
      if (item.ordinaryRates && item.ordinaryRates[platform]) return item.ordinaryRates[platform]
      const platformEntry = this.getPlatformEntry(item, platform)
      return platformEntry && platformEntry.rate ? platformEntry.rate : 0
    },
    getPlatformRateCurrency(item, platform) {
      if (item.ordinaryRates && item.ordinaryRates[`${platform}Currency`]) return item.ordinaryRates[`${platform}Currency`]
      const platformEntry = this.getPlatformEntry(item, platform)
      return (platformEntry && platformEntry.rateCurrency) || 'SGD'
    },
    getPlatformEntry(item, platform) {
      const directHandle = item[`${platform}Handle`]
      if (directHandle) {
        const cleanHandle = String(directHandle).replace(/^@/, '')
        const platformUrls = {
          linkedin: `https://www.linkedin.com/in/${cleanHandle}`,
          twitter: `https://x.com/${cleanHandle}`,
          facebook: `https://www.facebook.com/${cleanHandle}`,
          youtube: `https://www.youtube.com/@${cleanHandle}`,
          twitch: `https://www.twitch.tv/${cleanHandle}`
        }
        return {
          handle: directHandle,
          url: platformUrls[platform] || ''
        }
      }
      if (item.platforms) {
        if (Array.isArray(item.platforms)) {
          const normalizedPlatform = platform === 'twitter' ? ['twitter', 'x', 'x (twitter)'] : [platform]
          const matchPlatform = item.platforms.find(p => normalizedPlatform.includes(String(p.platform || '').trim().toLowerCase()))
          if (matchPlatform) {
            return matchPlatform
          }
        }
      }
      return null
    },
    getHandlePreview(item, platform) {
      const platformEntry = this.getPlatformEntry(item, platform)
      const savedHandle = platformEntry && (platformEntry.handle || platformEntry.username || platformEntry.userHandle || platformEntry.name)
      if (savedHandle) {
        return String(savedHandle).replace(/^@/, '')
      }

      const url = this.getPlatformUrl(item, platform)
      if (!url) return ''
      if (url.includes('watch?')) return url

      const cleanUrl = String(url).trim().replace(/[?#].*$/, '').replace(/\/+$/, '')
      let result = ''
      try {
        const parsedUrl = new URL(cleanUrl)
        const pathSegments = parsedUrl.pathname.split('/').filter(Boolean)
        if (pathSegments.length) {
          return decodeURIComponent(pathSegments[pathSegments.length - 1])
        }
      } catch (error) {
        const lastSlashIndex = cleanUrl.lastIndexOf('/')
        result = lastSlashIndex >= 0 ? cleanUrl.substring(lastSlashIndex + 1) : cleanUrl
        if (result) return result
      }
      return platform === 'facebook' ? 'Facebook profile' : result
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (Object.keys(this.colStatuses).length) {
        tmpStatuses = Object.assign({}, this.colStatuses)
      } else {
        this.headers.map(header => {
          tmpStatuses[header.value] = true
        })
      }
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.headers)) {
        if (value.text) {
          this.tableColsItems.push({
            title: value.text,
            key: value.value,
            value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
          })
        }
      }
      this.colSettingsDialog = true
    },
    async updateTableCols(items) {
      let columns = this.colStatuses
      items.map(item => {
        columns[item.key] = item.value
      })
      let tableSettings = {}
      if (this.userProfile.tableSettings) {
        tableSettings = this.userProfile.tableSettings
      }
      tableSettings.rateCardCols = Object.assign({}, columns)
      let updateData = {
        id: this.currentUserID,
        tableSettings
      }
      await userAPIs.editUser(updateData)
      // localStorage.setItem('MasterListCols', JSON.stringify(columns))
      this.colStatuses = Object.assign({}, columns)
      this.colSettingsDialog = false
    },
    async getUserProfile() {
      let resp = await userAPIs.getUser(this.currentUserID)
      if (resp && resp.id) {
        this.userProfile = resp
      }
    },
    async downloadRateCardRpt() {
      this.isLoading = true
      let rateCardIds = this.filteredItems.map(i => i.id)
      let data = {
        rateCardIds
      }
      influencerAPIs
        .downloadRateCardRpt(data)
        .then(() => {
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.log('error in downloading rate card report', error);
        });
    },
    searchFilter() {
      this.filteredItems = Object.assign([], this.items)
      if (this.filters.country) {
        this.filteredItems = this.filteredItems.filter(f => f.country === this.filters.country)
      }
      if (this.filters.category) {
        let categoryTh = influencerHelper.getCategories('th')
        let categoryVn = influencerHelper.getCategories('vn')
        let categoryId = influencerHelper.getCategories('id')
        let categoryCn = influencerHelper.getCategories('cn')
        let catIdx = this.categories.findIndex(f => f === this.filters.category)
        this.filteredItems = this.filteredItems.filter(f => f.keywords.includes(this.filters.category) ||
          f.keywords.includes(categoryTh[catIdx]) ||
          f.keywords.includes(categoryVn[catIdx]) ||
          f.keywords.includes(categoryId[catIdx]) ||
          f.keywords.includes(categoryCn[catIdx])
        )
      }
      if (this.filters.followers.from) {
        let from = this.filters.followers.from.replace('K', '000').replace('M', '000000')
        this.filteredItems = this.filteredItems.filter(f => f.igFollowerCount >= Number(from))
      }
      if (this.filters.followers.to) {
        let to = this.filters.followers.to.replace('K', '000').replace('M', '000000')
        this.filteredItems = this.filteredItems.filter(f => f.igFollowerCount <= Number(to))
      }
      if (this.filters.tiktokFollowers.from) {
        let from = this.filters.tiktokFollowers.from.replace('K', '000').replace('M', '000000')
        this.filteredItems = this.filteredItems.filter(f => f.tiktokFollowerCount >= Number(from))
      }
      if (this.filters.tiktokFollowers.to) {
        let to = this.filters.tiktokFollowers.to.replace('K', '000').replace('M', '000000')
        this.filteredItems = this.filteredItems.filter(f => f.tiktokFollowerCount <= Number(to))
      }
      if (this.filters.isTikTokEmpty) {
        this.filteredItems = this.filteredItems.filter(f => !f.tiktokFollowerCount)
      }
      if (this.filters.isIgEmpty) {
        this.filteredItems = this.filteredItems.filter(f => !f.igFollowerCount)
      }
      if (this.filters.dateOfBirth) {
        this.filteredItems = this.filteredItems.filter(f => f.dateOfBirth && f.dateOfBirth.includes(this.filters.dateOfBirth))
      }
      if (this.filters.starOnly) {
        this.filteredItems = this.filteredItems.filter(f => f.star)
      }
      if (this.filters.mainCategory) {
        this.filteredItems = this.filteredItems.filter(f => f.mainCategories && f.mainCategories.includes(this.filters.mainCategory))
      }
      if (this.filters.subCategory) {
        this.filteredItems = this.filteredItems.filter(f => f.subCategories && f.subCategories.includes(this.filters.subCategory))
      }
      // Filter by Content Type and Rate
      if (this.filters.contentType) {
        let contentTypeValue = this.filters.contentType.value
        this.filteredItems = this.filteredItems.filter(f => {
          let rates = f.ordinaryRates || {}
          let rateValue = rates[contentTypeValue]
          if (!rateValue) return false
          
          // Filter by currency if selected
          if (this.filters.rateCurrency) {
            let currencyKey = contentTypeValue + 'Currency'
            if (rates[currencyKey] !== this.filters.rateCurrency) {
              return false
            }
          }
          
          // Filter by rate range
          if (this.filters.rate.from !== '' && this.filters.rate.from !== null) {
            if (Number(rateValue) < Number(this.filters.rate.from)) {
              return false
            }
          }
          if (this.filters.rate.to !== '' && this.filters.rate.to !== null) {
            if (Number(rateValue) > Number(this.filters.rate.to)) {
              return false
            }
          }
          
          return true
        })
      }
      // For Sortings
      let sortCol = this.sort.column
      let sortType = this.sort.type === 'Ascending' ? 'asc' : 'desc'
      this.filteredItems = this.filteredItems.map(f => {
        if (f.igFollowerCount) {
          f.igFollowerCount = Number(f.igFollowerCount)
        }
        if (f.tiktokFollowerCount) {
          f.tiktokFollowerCount = Number(f.tiktokFollowerCount)
        }
        let rates = f.ordinaryRates || {}
        if (rates.igStory) {
          f.igStory = Number(rates.igStory)
          f.igStoryCurrency = rates.igStoryCurrency
        }
        if (rates.igPost) {
          f.igPost = Number(rates.igPost)
          f.igPostCurrency = rates.igPostCurrency
        }
        if (rates.igCarousel) {
          f.igCarousel = Number(rates.igCarousel)
          f.igCarouselCurrency = rates.igCarouselCurrency
        }
        if (rates.igVideo) {
          f.igVideo = Number(rates.igVideo)
          f.igVideoCurrency = rates.igVideoCurrency
        }
        if (rates.igReel) {
          f.igReel = Number(rates.igReel)
          f.igReelCurrency = rates.igReelCurrency
        }
        if (rates.igTv) {
          f.igTv = Number(rates.igTv)
          f.igTvCurrency = rates.igTvCurrency
        }
        if (rates.loadingFee) {
          f.loadingFee = Number(rates.loadingFee)
          f.loadingFeeCurrency = rates.loadingFeeCurrency
        }
        if (rates.eventAppearance) {
          f.eventAppearance = Number(rates.eventAppearance)
          f.eventAppearanceCurrency = rates.eventAppearanceCurrency
        }
        if (rates.tiktok) {
          f.tiktok = Number(rates.tiktok)
          f.tiktokCurrency = rates.tiktokCurrency
        }
        return f
      })
      if (sortCol === 'IG followers') {
        this.filteredItems = this.filteredItems.filter(f => f.igFollowerCount)
        this.filteredItems = orderBy(this.filteredItems, ['igFollowerCount'], [sortType])
      }
      if (sortCol === 'TikTok followers') {
        this.filteredItems = this.filteredItems.filter(f => f.tiktokFollowerCount)
        this.filteredItems = orderBy(this.filteredItems, ['tiktokFollowerCount'], [sortType])
      }
      if (sortCol === 'Date of Birth') {
        this.filteredItems = this.filteredItems.filter(f => f.dateOfBirth)
        this.filteredItems = orderBy(this.filteredItems, ['dateOfBirth'], [sortType])
      }
      if (sortCol === 'Last Updated') {
        this.filteredItems = orderBy(this.filteredItems, ['updatedAt'], [sortType])
      }
      if (sortCol === 'IG Story') {
        this.filteredItems = this.filteredItems.filter(f => f.igStory)
        this.filteredItems = orderBy(this.filteredItems, ['igStory'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.igStoryCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'IG Post') {
        this.filteredItems = this.filteredItems.filter(f => f.igPost)
        this.filteredItems = orderBy(this.filteredItems, ['igPost'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.igPostCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'IG Carousel') {
        this.filteredItems = this.filteredItems.filter(f => f.igCarousel)
        this.filteredItems = orderBy(this.filteredItems, ['igCarousel'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.igCarouselCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'IG Reel') {
        this.filteredItems = this.filteredItems.filter(f => f.igReel)
        this.filteredItems = orderBy(this.filteredItems, ['igReel'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.igReelCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'Loading Fee') {
        this.filteredItems = this.filteredItems.filter(f => f.loadingFee)
        this.filteredItems = orderBy(this.filteredItems, ['loadingFee'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.loadingFeeCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'Event Attendance') {
        this.filteredItems = this.filteredItems.filter(f => f.eventAppearance)
        this.filteredItems = orderBy(this.filteredItems, ['eventAppearance'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.eventAppearanceCurrency === this.sort.currency)
        }
      }
      if (sortCol === 'TikTok') {
        this.filteredItems = this.filteredItems.filter(f => f.tiktok)
        this.filteredItems = orderBy(this.filteredItems, ['tiktok'], [sortType])
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(f => f.tiktokCurrency === this.sort.currency)
        }
      }
    },
    formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>')
      }
      return text
    },
    async deleteRateCard(id) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true;
          let payload = Object.assign({}, {
            id
          })
          await this.$store.dispatch('influencer/deleteRateCard', payload)
          this.isLoading = false;
          if (!this.savedRateCard) {
            this.$swal({
              text: 'Error Deleting Rate Card.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully deleted.',
            type: 'success'
          });
          await this.getRateCardLists()
          this.searchFilter()
        }
      });
    },
    async chgStarStatus(item, status) {
      this.isLoading = true
      let data = [
        {
          id: item.id,
          star: status
        }
      ]
      // Submit request to save star data
      await this.$store.dispatch('influencer/updateRateCardByIds', data)
      this.isLoading = false
      if (this.savedRateCard) {
        let matchIdx = this.filteredItems.findIndex(f => f.id === item.id)
        this.filteredItems[matchIdx].star = status
        this.filteredItems = Object.assign([], this.filteredItems)
      }
    },
    resetFilters() {
      this.filters = {
        country: '',
        category: '',
        mainCategory: '',
        subCategory: '',
        dateOfBirth: '',
        followers: {from: '', to: ''},
        tiktokFollowers: {from: '', to: ''},
        contentType: '',
        rateCurrency: '',
        rate: {from: '', to: ''},
        isTikTokEmpty: false,
        isIgEmpty: false,
        starOnly: false
      }
      this.filter = ''
    },
    cancelDOB() {
      this.dateOfBirthCal = false
      this.searchFilter()
    },
    searchIGFollower() {
      this.sort.column = 'IG followers'
      this.sort.type = 'Descending'
      this.searchFilter()
    },
    searchTikTokFollower() {
      this.sort.column = 'TikTok followers'
      this.sort.type = 'Descending'
      this.searchFilter()
    },
    async changeLabel(item) {
      this.isLoading = true
      let data = [
        {
          id: item.id,
          mainCategories: item.mainCategories,
          subCategories: item.subCategories
        }
      ]
      // Submit request to save star data
      await this.$store.dispatch('influencer/updateRateCardByIds', data)
      this.isLoading = false
      if (this.savedRateCard) {
        this.filteredItems = Object.assign([], this.filteredItems)
      }
    }
  }
}
</script>
<style>
  .rate-card-search-page {
    padding: 0 12px 16px;
  }
  .rate-card-search-panel,
  .rate-card-results-panel {
    border: 1px solid #e5e8f0;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(35, 39, 76, .05);
  }
  .rate-card-search-panel {
    margin-bottom: 14px;
    padding: 14px;
  }
  .rate-card-search-primary {
    display: flex;
    align-items: stretch;
    gap: 8px;
  }
  .rate-card-search-input {
    flex: 1 1 auto;
    min-width: 260px;
  }
  .rate-card-search-input .v-input__slot {
    min-height: 40px !important;
    border-radius: 9px !important;
    background: #fafbfe !important;
  }
  .rate-card-search-input fieldset {
    border-color: #dfe3ec !important;
  }
  .rate-card-search-submit,
  .rate-card-filters-toggle,
  .rate-card-reset-toggle {
    height: 40px !important;
    border-radius: 9px !important;
    font-weight: 700 !important;
    letter-spacing: 0 !important;
    text-transform: none !important;
  }
  .rate-card-search-submit {
    min-width: 104px !important;
    box-shadow: 0 8px 18px rgba(67, 78, 151, .2) !important;
  }
  .rate-card-filter-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 19px;
    height: 19px;
    margin-left: 7px;
    padding: 0 5px;
    border-radius: 999px;
    background: #4c5bd4;
    color: #fff;
    font-size: 10px;
    font-weight: 800;
  }
  .rate-card-filters-accordion {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #eff1f5;
  }
  .rate-card-advanced-filters__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  .rate-card-advanced-filters__header > div {
    display: flex;
    flex-direction: column;
  }
  .rate-card-advanced-filters__header span {
    color: #252c40;
    font-size: 13px;
    font-weight: 800;
  }
  .rate-card-advanced-filters__header small {
    color: #8b92a5;
    font-size: 11px;
  }
  .rate-card-filter-bar {
    margin: 0;
    padding: 0 !important;
    border: 0;
    background: transparent;
  }
  .rate-card-filter-bar > .row {
    display: grid;
    grid-template-columns: repeat(5, minmax(150px, 1fr));
    gap: 10px;
    justify-content: stretch !important;
    width: 100%;
    margin: 0 !important;
  }
  .rate-card-filter-bar > .row > [class*="col-"] {
    width: auto !important;
    min-width: 0 !important;
    max-width: none !important;
    padding: 0 !important;
  }
  .rate-card-filter-bar .v-input,
  .rate-card-filter-bar .v-input[style] {
    max-width: none !important;
  }
  .rate-card-filter-bar .v-input__slot {
    min-height: 40px !important;
    border-radius: 8px !important;
  }
  .rate-card-filter-legacy-tool {
    display: none !important;
  }
  .rate-card-filter-bar .v-btn {
    letter-spacing: 0;
    text-transform: none;
  }
  .rate-card-content-type-option {
    display: inline-flex;
    align-items: center;
    min-width: 0;
    gap: 8px;
  }
  .rate-card-content-type-option--selected {
    gap: 6px;
  }
  .rate-card-content-type-option .v-icon {
    color: var(--media-icon-color) !important;
    caret-color: var(--media-icon-color) !important;
  }
  .rate-card-content-type-option img {
    display: block;
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
  .rate-card-content-type-input.v-input--is-focused fieldset {
    border-color: #3f3fff !important;
  }
  .rate-card-content-type-input .v-input__icon--clear .v-icon,
  .rate-card-content-type-input .v-input__icon--append .v-icon,
  .rate-card-rate-input .v-input__icon--clear .v-icon,
  .rate-card-rate-input .v-input__icon--append .v-icon,
  .rate-card-content-type-input .v-icon.primary--text,
  .rate-card-rate-input .v-icon.primary--text {
    color: #3f3fff !important;
    caret-color: #3f3fff !important;
  }
  .rate-card-rate-input.v-input--is-focused fieldset {
    border-color: #3f3fff !important;
  }
  .rate-card-rate-actions {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .rate-card-table {
    overflow: hidden;
    border: 1px solid #e6e8ef;
    border-radius: 12px;
    box-shadow: 0 3px 12px rgba(35, 39, 76, .06) !important;
  }
  .rate-card-results-panel {
    overflow: hidden;
  }
  .rate-card-results-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 52px;
    padding: 8px 14px;
    border-bottom: 1px solid #edf0f5;
  }
  .rate-card-results-count {
    color: #7b8295;
    font-size: 12px;
    font-weight: 650;
  }
  .rate-card-results-count strong {
    margin-right: 3px;
    color: #252c40;
    font-size: 14px;
  }
  .rate-card-results-toolbar__actions {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .rate-card-column-settings {
    color: #3f3fff !important;
  }
  .rate-card-column-settings .fas {
    color: #3f3fff !important;
  }
  .rate-card-column-settings:hover,
  .rate-card-column-settings:focus {
    background: rgba(63, 63, 255, .08) !important;
  }
  .rate-card-results-panel .rate-card-table {
    border: 0;
    border-radius: 0;
    box-shadow: none !important;
  }
  .rate-card-table .v-data-table__wrapper > table > thead > tr > th {
    height: 52px;
    color: #4f5368 !important;
    font-size: 12px !important;
    font-weight: 700;
    white-space: nowrap;
    background: #f7f8fb;
  }
  .rate-card-table .v-data-table__wrapper > table > tbody > tr:hover {
    background: #f8f9ff !important;
  }
  .rate-card-table .v-data-table__wrapper > table > tbody > tr > td {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  #rate-card-data-table tbody tr td {
    min-width: 100px!important;
  }
  #rate-card-data-table tbody td .remark-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
  }
  @media (max-width: 1100px) {
    .rate-card-filter-bar > .row {
      grid-template-columns: repeat(3, minmax(150px, 1fr));
    }
  }
  @media (max-width: 760px) {
    .rate-card-search-primary {
      align-items: stretch;
      flex-direction: column;
    }
    .rate-card-search-input {
      min-width: 0;
    }
    .rate-card-filter-bar > .row {
      grid-template-columns: 1fr;
    }
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?37221b0e